import s from "./CountriesBlueButtons.module.scss";
import { Link, useLocation, useParams } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import {
  getKyrgyzstanCheckupList,
  getTajikistanCheckupList,
  getUzbekistanCheckupList,
} from "../../redux/InformationSlice";
import { useTranslation } from "react-i18next";

const CountriesBlueButtons = () => {
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className={s.buttons}>
      <Link
        to={"/checkup/tajikistan"}
        className={
          location.pathname.split("/").pop() === "tajikistan" ? s.active : s.btn
        }
        onClick={() => dispatch(getTajikistanCheckupList())}
      >
        {t("В ТАДЖИКИСТАНЕ")}
      </Link>
      <Link
        to={"/checkup/kyrgyzstan"}
        className={
          location.pathname.split("/").pop() === "kyrgyzstan" ? s.active : s.btn
        }
        onClick={() => dispatch(getKyrgyzstanCheckupList())}
      >
        {t("В КЫРГЫЗСТАНЕ")}
      </Link>
      <Link
        to={"/checkup/uzbekistan"}
        className={
          location.pathname.split("/").pop() === "uzbekistan" ? s.active : s.btn
        }
        onClick={() => dispatch(getUzbekistanCheckupList())}
      >
        {t("В УЗБЕКИСТАНЕ")}
      </Link>
    </div>
  );
};

export default CountriesBlueButtons;
